module.exports = __webpack_public_path__ + "media/src/img/payment/tinkoff_logo_mini-b19bc1b420b41b78ab1d2b224bf5ff8b.svg";